import * as React from 'react';
import { IRegimenContext } from '..';
import FormRow from '../../../../../../../components/FormRow';
import InputHandler from '../../../../../../../components/InputHandler';
import { StrengthSelect } from '../components/StrengthSelect';
import UnitSelect from '../components/UnitSelect';
import { otherOnChange, strengthsArray, strengthsOnChange } from '../utils';
import { path } from 'Utility/ramdaReplacement';

const SingleDose = ({ formData, editIndex, packages }: IRegimenContext): React.JSX.Element => {
  const regimen = formData.document?.regimen?.[editIndex] as IRegimenBasics & IRegimenSingleDose;
  const allRegimen = formData.document?.regimen as Array<Regimen>;
  const availableStrengths = strengthsArray(packages);
  const strengths = regimen.strengths || [];

  return (
    <React.Fragment>
      <StrengthSelect
        formData={formData}
        availableStrengths={availableStrengths}
        strengthsOnChange={strengthsOnChange(formData.onChange, availableStrengths, editIndex, regimen, allRegimen)}
        strengths={strengths}
        editIndex={editIndex}
      />
      <FormRow title="medication.dose" headerWidth={3}>
        <InputHandler
          type="NumberField"
          name="dose"
          editing={true}
          placeholder={'medication.dose'}
          precision={4}
          width={19}
          formData={{
            onChange: otherOnChange(formData.onChange, editIndex, regimen, allRegimen),
            document: { dose: path(['document', 'regimen', editIndex, 'dose'], formData) || '' },
          }}
        />
      </FormRow>

      <UnitSelect
        unitValue={path(['document', 'regimen', editIndex, 'unit'], formData)}
        onChange={otherOnChange(formData.onChange, editIndex, regimen, allRegimen)}
      />
    </React.Fragment>
  );
};

export default SingleDose;
